export const downloadResume = (e) => {
  if (e) {
    e.preventDefault(); // Prevent default anchor behavior
  }
  
  // Create a link element to trigger download
  const link = document.createElement('a');
  link.href = '/resume.pdf'; // This will be the path to your resume file
  link.download = 'Subeksha_Thapa_Resume.pdf';
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
